module.exports = __webpack_public_path__ + "static/media/icon_quanhou.a433e823.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/activity/icon_quanhou.svg
// module id = 146
// module chunks = 0